<template>
  <div>
    <!-- <label>
      Inhalt<br />
    </label> -->
    <codemirror ref="myCm" :options="cmOptions"></codemirror>
    <SimpleUpload @imageAdded="addImage($event)"></SimpleUpload>
  </div>
</template>
<script>
import firebase from 'firebase/app'
import { codemirror } from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
import 'firepad/dist/firepad.css'
import Firepad from 'firepad/dist/firepad.js' // eslint-disable-line
import SimpleUpload from '@/components/SimpleUpload'

var db = firebase.database()
var firepad = null

export default {
  props: ['hash'],
  components: {
    codemirror,
    SimpleUpload
  },
  methods: {
    initFirepad: function () {
      firepad = Firepad.fromCodeMirror(db.ref().child('testeditor').child(this.hash), this.codemirror,
        { richTextShortcuts: true, richTextToolbar: true }
        //, userId: userId
      )
      firepad.on('ready', function () {
        // this.firepadReady = true
      })
    },
    setHash: function (newVal, oldVal) {
      // console.log('hans')
    },
    addImage: function (url) {
      firepad.insertEntity('img', { 'src': url })
    }
  },
  data () {
    return {
      firepadReady: false,
      cmOptions: {
        // codemirror options
        // tabSize: 4,
        viewportMargin: Infinity,
        lineWrapping: true
        // mode: 'text/javascript',
        // theme: 'base16-dark',
        // lineNumbers: true,
        // line: true
        // readOnly: true
      }
    }
  },
  computed: {
    codemirror () {
      return this.$refs.myCm.codemirror
    }
  },
  mounted () {
    this.initFirepad()
  },
  beforeDestory () {
    // console.log('destroy')
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/EditorFirepad.vue